<template>
  <div class="brand">
    <utopa-title :title="showData.TITLE.title"></utopa-title>
    <card2 v-for="card in showData.CARDS"
           :key="card.id"
           :img="card.img"
           :title="card.title"
           :des="card.des"
           :leftEle="card.leftEle"
           @toInfo='toInfo(card)'></card2>
  </div>
</template>

<script>
import language from 'mixins/language' // 预留 多语言混入实例
import card2 from 'components/card2.vue'
import utopaTitle from 'components/title.vue'
export default {
  name: '',
  mixins: [language],
  props: [''],
  data () {
    return {
      CN: {
        TITLE: {
          title: '主力品牌'
        },
        CARDS: [
          { img: require('images/brand/1.png'), title: 'GT WORK', des: '任何时间、任何地点服务客户，助力客户事业成功', id: 1, leftEle: 'img' },
          { img: require('images/brand/2.png'), title: '天为食', des: '致力于打造以“智能科技+餐饮社交文化”的美食娱乐体验', id: 2, leftEle: 'txt' },
          { img: require('images/brand/3.png'), title: 'Liber Fashion', des: '时尚是自由的，顾客可以自由选择属于自己的时尚', id: 3, leftEle: 'img' },
          { img: require('images/brand/4.png'), title: '童年时光', des: '陪伴儿童快乐健康成长', id: 4, leftEle: 'txt' },
          { img: require('images/brand/5.png'), title: '美居生活', des: '以艺术、阅读与音乐为语言，追求喜悦与欢笑为生活态度 ，充实人们的精神生活', id: 5, leftEle: 'img' },
          { img: require('images/brand/6.png'), title: '活力基地', des: '为全民带来健康与活力', id: 6, leftEle: 'txt' }
        ]
      },
      ZH: {
        TITLE: {
          title: '主力品牌'
        },
        CARDS: [
          { img: require('images/brand/1.png'), title: 'GT WORK', des: '任何時間、任何地點服務客戶，助力客戶事業成功', id: 1, leftEle: 'img' },
          { img: require('images/brand/2.png'), title: '天为食', des: '致力於打造以“智慧科技+餐飲社交文化”的美食娛樂體驗', id: 2, leftEle: 'txt' },
          { img: require('images/brand/3.png'), title: 'Liber Fashion', des: '時尚是自由的，顧客可以自由選擇屬於自己的時尚', id: 3, leftEle: 'img' },
          { img: require('images/brand/4.png'), title: '童年时光', des: '陪伴兒童快樂健康成長', id: 4, leftEle: 'txt' },
          { img: require('images/brand/5.png'), title: '美居生活', des: '以藝術、閱讀與音樂為語言，追求喜悅與歡笑為生活態度 ，充實人們的精神生活', id: 5, leftEle: 'img' },
          { img: require('images/brand/6.png'), title: '活力基地', des: '為全民帶來健康與活力', id: 6, leftEle: 'txt' }
        ]
      }
    }
  },
  components: { card2, utopaTitle },
  watch: {},
  computed: {},
  created () { },
  mounted () { },
  methods: {
    toInfo (card) {
      this.$router.push({
        name: 'mBrandInfo',
        params: {
          id: card.id
        }
      })
    }
  }
}

</script>
<style lang='scss' scoped>
@import "px2rem";
.brand {
  padding-top: px2rem(54);
}
</style>
